import React from 'react';
import { Button, Col, Progress } from 'reactstrap';

const LotImageUploading = ({ cancelDeleteOnClick, fileName, imageSrc, progress }) => (
  <Col xs={3} className="file-container py-3">
    <div className="file-border px-3 pt-2">
      <div className="d-flex">{fileName}</div>
      <div className="thumb-container d-flex justify-content-center align-items-center mt-2 mb-3">
        {imageSrc && <img className="w-100 mh-100" src={imageSrc} alt="No Thumbnail" />}
      </div>
      <Progress className="mb-2" value={progress} />
      <Button className="mt-0" color="link" onClick={cancelDeleteOnClick}>
          Cancel upload
      </Button>
    </div>
  </Col>
);

export default LotImageUploading;
